<template>
  <div :class="$style.root">
    <el-card>
      <div slot="header">
        <span>缴费查询</span>
      </div>
      <el-row>
        <el-col :span="4">
          <el-select v-model="selectedStationKind" placeholder="请选择测点类型" @change="criteria.stationcode = null">
            <el-option v-for="item in stationKindList" :key="item.stationtype" :label="item.stationtypeName" :value="item.stationtype">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="criteria.stationcode" placeholder="请选择测点">
            <el-option v-for="item in stationListByType" :key="item.FYCD" :label="item.FYNM" :value="item.FYCD">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="criteria.stime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="criteria.etime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <div style="padding-left: 8px;">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </div>
        </el-col>
        <el-col :span="4">
          <div style="float:right;">
            <router-link :to="{path:'waterfee-payment-history-search'}" style="float:right;">
              <el-button type="primary" plain>缴费记录 ></el-button>
            </router-link>
          </div>
        </el-col>
      </el-row>
      <br>

      <el-table :data="list" border style="width: 100%" v-loading="loading">
        <el-table-column prop="stationcode" label="测点编码" width="240">
          <template slot-scope="scope">
            {{criteria.stationcode}}
          </template>
        </el-table-column>
        <el-table-column prop="stationname" label="测点名称">
          <template slot-scope="scope">
            {{stationKeyByCode[criteria.stationcode].FYNM}}
          </template>
        </el-table-column>
        <el-table-column prop="stime" label="开始时间" width="180">
          <template slot-scope="scope">
            {{criteria.stime.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="etime" label="结束时间" width="180">
          <template slot-scope="scope">
            {{criteria.stime.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="总用水量" width="180"></el-table-column>
        <el-table-column prop="total_price" label="总费用" width="180"></el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <router-link :to="{path: `waterfee-payment-pay?${generateQueries(scope.row)}`}">
              <el-button type="text">缴费</el-button>
            </router-link>
            <el-button type="text" @click="showDetail(scope.$index, scope.row)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <div slot="title">
        <span>{{criteria.stime && criteria.stime.split(' ')[0]}} ~ {{criteria.etime && criteria.etime.split(' ')[0]}} 明细数据</span>
      </div>
      <el-card v-if="selectedRow !== null">
        <payment-detail
          :stationcode="criteria.stationcode"
          :stationname="stationKeyByCode[criteria.stationcode].FYNM"
          :list="detailList[selectedRow]">
        </payment-detail>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {
  stationquery,
  getallstationkind,
  getPriceReport
} from "@/apis/api"
import qs from 'qs'
import {PAYMENT_PAID} from '../topics'
import PaymentDetail from '../components/payment-detail'

export default {
  name: 'payment-search',
  data() {
    return {
      loading: false,

      list: [],
      criteria: {
        stationcode: null,
        stime: null,
        etime: null,
        // stationcode: '5640003',
        // stime: '2015-01-01',
        // etime: '2015-12-31',
      },

      selectedStationKind: null,
      stationKindList: [],
      stationList: [],

      dialogVisible: false,
      selectedRow: null
    }
  },
  computed: {
    stationListByType() {
      if(this.selectedStationKind) {
        return this.stationList.filter(item => item.StationType === this.selectedStationKind)
      } else {
        return this.stationList
      }
    },
    stationKeyByCode() {
      return this.stationList.reduce((map, obj) => {
        map[obj.FYCD] = obj
        return map
      }, {})
    },
    detailList() {
      return this.list.map(item => item.detail)
    }
  },
  created() {
    this.fetchStationList()
    this.fetchStationKindList()
  },
  methods: {
    generateQueries(row) {
      return qs.stringify(Object.assign({
        stationname: this.stationKeyByCode[this.criteria.stationcode].FYNM,
        quantity: row.quantity,
        total_price: row.total_price
      }, this.criteria))
    },
    fetchStationList() {
      stationquery({regioncode: sessionStorage.getItem('regioncode'),
   userid:JSON.parse(sessionStorage.getItem('userInfo')).uuid   }).then(res => {
        this.stationList = res.result
      })
    },
    fetchStationKindList() {
      getallstationkind().then(res => {
        this.stationKindList = res.result
      })
    },
    fetchCostData() {
      this.loading = true
      getPriceReport({
        fycd: this.criteria.stationcode,
        stime: this.criteria.stime,
        etime: this.criteria.etime,
      }).then(res => {
        this.list = res.result ? [res.result]: []
        this.loading = false
      })
    },
    search() {
      if(!this.criteria.stationcode || !this.criteria.stime || !this.criteria.etime) {
        this.$message({
          message: '请选择测点和起止时间',
          type: 'warning'
        })
        return
      }
      this.fetchCostData()
    },
    showDetail(index) {
      this.dialogVisible = true
      this.selectedRow = index
    },
    handleClose(done) {
      this.selectedRow = null
      done()
    }
  },
  components: {
    PaymentDetail
  }
}
</script>

<style lang="less" module>
.root {
  padding: 1em;
}
.root, .root > :global(.el-card){
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/payment/search.vue